import React from 'react'
import authSelector from '../../selectors/authSelector'
import { connect } from 'react-redux'
import { FETCH_USER_STATS_REQUEST } from '../../actions/actions'
import Splitter from '../../helpers/Splitter'

const ComponentByUserType = {
  TEACHER: Splitter(() => import('../teacher/TeacherStats')),
  SUPERVISOR: Splitter(() => import('../supervisor/ViewSupervisorEventsContainer')),
  MANAGER: Splitter(() => import('../manager/ManagerStats')),
  STUDENT: Splitter(() => import('../common/FeaturedItems')),
  SCHOOL: Splitter(() => import('../common/FeaturedItems')),
}

class DashboardSummeryContainer extends React.Component {
  constructor(props) {
    super(props)
    const { dispatch, userType } = this.props

    if (userType === 'MANAGER' || userType === 'TEACHER') {
      dispatch({ type: FETCH_USER_STATS_REQUEST })
    }
  }

  render() {
    const TheComponent = ComponentByUserType[this.props.userType]
    if (!TheComponent) return <div />

    return <TheComponent userStats={this.props.userStats} />
  }
}

const mapStatToProps = state => ({
  ...authSelector(state),
  userStats: state.userStats.stats,
})

export default connect(mapStatToProps)(DashboardSummeryContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardSummeryContainer.js